import React from "react";
import {connect} from "react-redux";
import Leistungen from "../components/Leistungen";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class LeistungenContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            refreshPageController: false
        }
    }

    render() {
        return (
            <div>
                <Leistungen />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeistungenContainer);


// WEBPACK FOOTER //
// ./src/container/LeistungenContainer.js